/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Data_ErrorInputs */



/**
* | output |
* | --- |
* | "Oops! Something went wrong while fetching the data. Try reloading the page or return to the home page." |
*
* @param {Data_ErrorInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const data_error = /** @type {((inputs?: Data_ErrorInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Data_ErrorInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("Oops! Something went wrong while fetching the data. Try reloading the page or return to the home page.")
});